import { useProperty } from '@eti/providers';
import { useMediaQuery } from 'usehooks-ts';
const useDarkMode = () => {
  const {
    p
  } = useProperty();
  const isDarkModeEnabled = p('CustomerWeb.UseDarkModeTheme.Enabled');
  const isSystemDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  return {
    isDarkMode: isDarkModeEnabled && isSystemDarkMode
  };
};
export default useDarkMode;
//# sourceMappingURL=useDarkMode.js.map